import { Component, Input, OnInit } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { InvoiceService } from 'src/app/revenue/shared/invoice/invoice.service';
import { NotificationService, TranslationService } from 'src/app/shared';
import { NavigationService } from 'src/app/shared/navigation/navigation.service';
import { InvoiceUpsertDto } from '../../dto/invoice-upsert.dto';

@Component({
  selector: 'wl-invoice-delete',
  templateUrl: './invoice-delete.component.html',
  styleUrls: ['./invoice-delete.component.less'],
    standalone: false
})
export class InvoiceDeleteComponent implements OnInit {
  @Input() invoice: InvoiceUpsertDto;

  deleting = false;

  constructor(
    private _confirmationService: ConfirmationService,
    private _invoiceService: InvoiceService,
    private _navigationService: NavigationService,
    private _notificationService: NotificationService,
    private _translationService: TranslationService
  ) {}

  ngOnInit(): void {}

  deleteInvoice(invoice: InvoiceUpsertDto) {
    this._confirmationService.confirm({
      message: this._translationService.getInstant('invoices.invoice-builder.delete-tab.delete-confirm-message'),
      key: 'deleteInvoice',
      accept: () => {
        this.deleting = true;
        this._invoiceService
          .deleteInvoice(invoice.InvoiceHeader.InvoiceNum)
          .then(() => {
            this._navigationService.navigateToTransactionsView(invoice.InvoiceHeader.ProfileId);
          })
          .catch((err) => {
            this._notificationService.httpError(err);
          })
          .finally(() => {
            this.deleting = false;
          });
      },
      reject: () => {
        this._confirmationService.close();
      },
    });
  }
}
